import { call, put, takeLatest } from "redux-saga/effects";
import { journeyActions } from "../actions";
import api from "../services/journey.services";
import ACTIONS from "../constants";

function* getJourneySessions(state) {
  try {
    yield put(journeyActions.getJourneySessions.pending);
    const response = yield call(api.sessionsListRequest, state.payload);
    if (response?.data) {
      yield put(journeyActions.getJourneySessions.success(response));
    }
  } catch (error) {
    yield put(journeyActions.getJourneySessions.error(error));
  }
}

function* getJourneySessionDetail(state) {
  try {
    yield put(journeyActions.getJourneySessionDetail.pending(state.payload));
    const payload = state.payload;
    const sessionId = typeof payload === "string" ? payload : payload?.sessionId;
    const params = typeof payload === "object" && payload ? { page: payload.page, per_page: payload.per_page } : {};
    const response = yield call(api.sessionDetailRequest, sessionId, params);
    if (response) {
      yield put(journeyActions.getJourneySessionDetail.success({ ...response, append: payload?.append }));
    }
  } catch (error) {
    yield put(journeyActions.getJourneySessionDetail.error(error));
  }
}

function* getJourneyActiveUsers(state) {
  try {
    yield put(journeyActions.getJourneyActiveUsers.pending);
    const response = yield call(api.activeUsersRequest, state.payload);
    if (response) {
      yield put(journeyActions.getJourneyActiveUsers.success(response));
    }
  } catch (error) {
    yield put(journeyActions.getJourneyActiveUsers.error(error));
  }
}

export default function* journeySagas() {
  yield takeLatest(ACTIONS.JOURNEY_SESSIONS_LIST_CALL, getJourneySessions);
  yield takeLatest(ACTIONS.JOURNEY_SESSION_DETAIL_CALL, getJourneySessionDetail);
  yield takeLatest(ACTIONS.JOURNEY_ACTIVE_USERS_CALL, getJourneyActiveUsers);
}
